import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type { PagedResponse, Stakeholder, StakeholderStatus, StakeholderUpsert } from '../types'

const BASE = '/management/activity-stakeholders'

/** Silinmemiş kayıtların (sıralı) listesi. Lookup ölçeği küçük → tümünü tek sayfada çekeriz (size=200). */
export async function getStakeholders(): Promise<PagedResponse<Stakeholder>> {
  const { data } = await apiClient.get<PagedResponse<Stakeholder>>(BASE, {
    params: { page: 0, size: 200 },
  })
  return data
}

/** Yeni kayıt oluştur (201 → oluşturulan kayıt). */
export async function createStakeholder(body: StakeholderUpsert): Promise<Stakeholder> {
  const { data } = await apiClient.post<Stakeholder>(BASE, body)
  return data
}

/** Kaydı güncelle (ad/sıra; optimistic lock modDate zorunlu). */
export async function updateStakeholder(
  id: number,
  body: StakeholderUpsert,
): Promise<Stakeholder> {
  const { data } = await apiClient.put<Stakeholder>(`${BASE}/${id}`, body)
  return data
}

/** Durum değiştir (Aktif/Pasif; yalnız 0↔1). */
export async function changeStakeholderStatus(
  id: number,
  body: StakeholderStatus,
): Promise<Stakeholder> {
  const { data } = await apiClient.put<Stakeholder>(`${BASE}/${id}/status`, body)
  return data
}

/** Soft-delete (record_status=2). 204. */
export async function deleteStakeholder(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`)
}

/**
 * Yeniden sıralama — ekranda görünen tüm (silinmemiş) kayıtların id sırası. Backend bu sırayı 1..N
 * SORT_INDEX olarak yeniden yazar (pairwise takas değil; çift değeri onarır). 204.
 */
export async function reorderStakeholders(orderedIds: number[]): Promise<void> {
  await apiClient.put(`${BASE}/reorder`, { orderedIds })
}

/**
 * Paydaş/katılımcı listesini Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportStakeholders(): Promise<void> {
  await downloadXlsx(`${BASE}/export`, {}, 'paydaslar.xlsx')
}
